/*! track-focus v 1.0.0 | Author: Jeremy Fields [jeremy.fields@vget.com], 2015 | License: MIT */
// inspired by: http://irama.org/pkg/keyboard-focus-0.3/jquery.keyboard-focus.js

/**
 * Tracks an element is focused via the mouse or keyboard. On mouse focus, adds
 * the mouseClass to the element.
 *
 * Adapted from: https://github.com/ten1seven/track-focus/blob/master/src/javascripts/track-focus.js
 */

export const trackFocus = (el, mouseClass = 'focus--mouse') => {
    let usingMouse;

    function preFocus(event) {
        usingMouse = event.type === 'mousedown';
    }

    function addFocus() {
        if (usingMouse) el.classList.add(mouseClass);
    }

    function removeFocus() {
        el.classList.remove(mouseClass);
    }

    function bindEvents() {
        el.addEventListener('keydown', preFocus);
        el.addEventListener('mousedown', preFocus);
        el.addEventListener('focusin', addFocus);
        el.addEventListener('focusout', removeFocus);
    }

    function unbindEvents() {
        el.removeEventListener('keydown', preFocus);
        el.removeEventListener('mousedown', preFocus);
        el.removeEventListener('focusin', addFocus);
        el.removeEventListener('focusout', removeFocus);
    }

    bindEvents();

    return unbindEvents;
};

/** Given a cookie string returns an object of key-value pairs. */
export const parseCookie = (cookie) => {
    return (cookie || '')
        .split(';')
        .map((e) => e.trim())
        .reduce((memo, cookie) => {
            const parts = cookie.split('=');
            memo[parts[0]] = parts[1];
            return memo;
        }, {});
};

/** Given an object of key-value pairs, returns a cookie string. */
export const stringifyCookie = (data) => {
    return Object.entries(data).reduce((cookie, [k, v]) => {
        return `${cookie}${k}=${v}; `;
    }, '');
};
